<template>
  <BasePageContainer class="pt-10">
    <PageHeader
      has-back
      with-members>
      前所属・経歴
    </PageHeader>
    <PastDepartmentsForm
      v-if="initialized"
      ref="form"
      :past-departments="pastDepartments"
      :api-errors="apiErrors"
      @submit="postPastDepartments" />
  </BasePageContainer>
</template>

<script>
import BasePageContainer from '@/components/parts/BasePageContainer.vue'
import PageHeader from '@/components/parts/PageHeader.vue'
import PastDepartmentsForm from '@/components/view/profile/past_departments/PastDepartmentsForm.vue'
import confirmIfFormChanged from '@/components/mixin/confirmIfFormChanged'
export default {
  components: {
    BasePageContainer,
    PageHeader,
    PastDepartmentsForm
  },
  mixins: [confirmIfFormChanged()],
  data() {
    return {
      pastDepartments: [],
      initialized: false,
      apiErrors: null
    }
  },
  computed: {
    userId() {
      return this.$route.params.id
    }
  },
  created() {
    this.fetchPastDepartments().finally(() => {
      this.initialized = true
    })
  },
  methods: {
    fetchPastDepartments() {
      return this.$axios.get('/profiles/past-departments/', {
        params: {
          user_id: this.userId
        }
      }).then(res => {
        this.pastDepartments = res.data.results
      })
    },
    postPastDepartments(data) {
      this.$store.commit('startLoading')
      return this.$axios.post('/profiles/past-departments/', {
        ...data,
        user: this.userId
      }).then(() => {
        this.$store.commit('notify/set', {message: '前所属・経歴を更新しました'})
        this.canLeave = true
        this.$nextTick(() => {
          this.$router.push(`/members/${this.userId}/profile`, { replace: true })
        })
      }).catch(err => {
        this.apiErrors = err.response.data
      }).finally(() => {
        this.$store.commit('finishLoading')
      })
    }
  }
}
</script>

<style>

</style>